import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { updateUMProps } from '../../../../stores/settings/userManagement/actions';
import { IconButton, Card, MenuItem, CardHeader, IconMenu, CardText, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui';
import R from 'ramda';
import { availableAccess } from '../teamPermissionOptions';
import NoLocs from './noLocs';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

const propTypes = {
  updateProp: PropTypes.func,
  locations: PropTypes.array,
  userId: PropTypes.string,
  locAccess: PropTypes.array,
  locationSort: PropTypes.array,
  triggerNoAccessWarning: PropTypes.func,
};

class LocView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // expandedLocId: '',
      sortBy: '', // name or email
      sortDirection: 'forward', // forward (a to z) or backward (z to a)
      sortedUsers: null,
    };
  }

  render() {
    const {
      updateProp,
      userId,
      locationSort,
      isAccom,
    } = this.props;

    const {
      // expandedLocId,
      sortDirection,
      sortedUsers,
      sortBy,
    } = this.state;
    const sortedByLocs = R.uniq(R.pluck('locId')(locationSort)).reduce((result, locId) => {
      result.push({
        locId,
        locName: R.uniq(R.pluck('locName')(locationSort.filter(loc => loc.locId === locId)))[0],
        users: locationSort.filter(loc => loc.locId === locId),
      });
      return result;
    }, []);

    const alphaSort = (toBeSorted, direction, fieldName) => {
      if (direction === 'forward') return toBeSorted.sort((a, b) => (a[fieldName] > b[fieldName]) ? 1 : ((b[fieldName] > a[fieldName]) ? -1 : 0));
      return toBeSorted.sort((a, b) => (a[fieldName] < b[fieldName]) ? 1 : ((b[fieldName] < a[fieldName]) ? -1 : 0));
    };

    const sortAZZA = (field, usersToSort) => (<IconButton
      iconClassName={R.equals(field, sortBy) ? R.equals(sortDirection, 'forward') ? 'tc-icon-move-down' : 'tc-icon-move-up' : 'tc-icon-move-down'}
      iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', marginTop: '5px' }}
      tooltip={R.equals(sortDirection, 'forward') ? 'A-Z' : 'Z-A'}
      onTouchTap={() => {
        const fieldName = field === 'email' ? 'email' : 'firstName';
        const sorted = R.equals(sortDirection, 'forward') ? alphaSort(usersToSort, 'forward', fieldName) : alphaSort(usersToSort, 'backwards', fieldName);
        this.setState({ sortBy: field, sortDirection: R.equals(sortDirection, 'forward') ? 'backward' : 'forward', sortedUsers: sorted });
      }}
    />);

    return (
      <div style={{ width: '100%' }}>
        {
          R.isEmpty(sortedByLocs) ?
            <NoLocs /> :
            <div>
              {
                sortedByLocs.map((loc, i) => {
                  const isUserInListOfLocUsers = R.contains(userId, R.pluck('userId')(loc.users));
                  const findUserObj = R.propOr({}, 0, loc.users.filter(obj => obj.userId === userId));
                  const userAccessInUserManagement = R.uniq(isUserInListOfLocUsers && findUserObj.admin ? findUserObj.admin : []);
                  const location = sortedByLocs.filter(obj => obj.locId === loc.locId);
                  const locationUsers = sortedUsers ? sortedUsers : R.pathOr([], [0, 'users'], location);
                  const numOfUsers = R.propOr(0, 'length', locationUsers);
                  const shouldCardExpand = numOfUsers > 0 && R.contains('read', userAccessInUserManagement);
                  return (
                    <Card
                      key={i}
                      onTouchTap={() => {
                        if (!R.contains('read', userAccessInUserManagement)) {
                          this.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'locationAccess', loc: R.omit(['users'], loc) } });
                        }
                      }}
                      style={{ backgroundColor: '#fafafa', boxShadow: 'none', borderBottom: R.equals(i, sortedByLocs.length - 1) ? '' : '1px solid #e0e0e0', marginBottom: '4px' }}
                    >
                      <CardHeader actAsExpander={shouldCardExpand} showExpandableButton={shouldCardExpand} textStyle={{ display: 'none' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '95%' }}>
                          <div>{loc.locName.charAt(0).toUpperCase() + loc.locName.slice(1)}</div>
                          <div>{numOfUsers} {R.equals(numOfUsers, 1) ? 'User' : 'Users'}</div>
                        </div>
                      </CardHeader>
                      <CardText expandable style={{ padding: 0 }}>
                        <div>
                          <Table wrapperStyle={{ overflow: 'visible' }} style={{ backgroundColor: '#fafafa' }} bodyStyle={{ overflow: 'visible' }}>
                            <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                              <TableRow>
                                <TableHeaderColumn style={{ width: '23%', textAlign: 'center' }}>
                                  <span>Name</span>
                                  {sortAZZA('name', locationUsers)}
                                </TableHeaderColumn>
                                <TableHeaderColumn style={{ width: '23%', textAlign: 'center' }}>
                                  <span>Email</span>
                                  {sortAZZA('email', locationUsers)}
                                </TableHeaderColumn>
                                <TableHeaderColumn style={{ width: '18%', textAlign: 'center' }}>Team(s)</TableHeaderColumn>
                                <TableHeaderColumn style={{ width: '9%', padding: 0, textAlign: 'center' }}>
                                  <div style={{ overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'pre-wrap', display: 'flex', alignContent: 'flex-start', justifyContent: 'flex-start' }}>
                                    Create {isAccom ? 'Property' : 'Location'}
                                  </div>
                                </TableHeaderColumn>
                                <TableHeaderColumn style={{ width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' }}>
                                  User <br/> Management
                                </TableHeaderColumn>
                                <TableHeaderColumn style={{ width: '9%', padding: 0, textAlign: 'center', overflow: 'hidden' }}>Contracting</TableHeaderColumn>
                                <TableHeaderColumn style={{ width: '9%' }} />
                              </TableRow>
                            </TableHeader>
                            <TableBody displayRowCheckbox={false}>
                              {
                                locationUsers.map((user, j) => {
                                  const userAccess = R.cond([
                                    [R.equals('profile'), R.always(isNilOrEmpty(user.profile) ? ['read'] : ['read', 'write'])],
                                    [R.T, feature => R.prop(0, R.pluck('value')(availableAccess.filter(obj => R.equals(obj.value, R.pathOr([], [j, feature], locationUsers)))))],
                                  ]);
                                  const accessIcons = R.cond([
                                    [R.equals(['read', 'write']), R.always(
                                      <span style={{ width: '100%' }}>
                                        <IconButton tooltip="Read Access" iconClassName="tc-icon-remove_red_eye" iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }} style={{ width: '50%' }}/>
                                        <IconButton tooltip="Write Access" iconClassName="tc-icon-mode_edit" iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }} style={{ width: '50%' }}/>
                                      </span>)],
                                    [R.equals(['read']), R.always(<span><IconButton tooltip="Read Access" iconClassName="tc-icon-remove_red_eye" iconStyle={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px', padding: 0, marginTop: '5px' }}/></span>)],
                                    [R.T, R.always(<span><IconButton tooltip="No Access" iconClassName="tc-icon-block" iconStyle={{ color: 'rgba(255, 64, 129, 0.8)', fontSize: '14px', padding: 0, marginTop: '5px' }}/></span>)],
                                  ]);
                                  return (
                                    <TableRow key={j}>
                                      <TableRowColumn style={{ width: '23%' }}>{`${user.firstName} ${user.lastName}`}</TableRowColumn>
                                      <TableRowColumn style={{ width: '23%' }}>{user.email}</TableRowColumn>
                                      <TableRowColumn style={{ width: '18%' }}>{user.teams.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0)).join(', ')}</TableRowColumn>
                                      <TableRowColumn style={{ width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3' }}>{accessIcons(userAccess('profile'))}</TableRowColumn>
                                      <TableRowColumn style={{ width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderLeft: '1px solid #D3D3D3', borderRight: '1px solid #D3D3D3' }}>{accessIcons(userAccess('admin'))}</TableRowColumn>
                                      <TableRowColumn style={{ width: '9%', padding: 0, overflow: 'visible', textAlign: 'center', borderRight: '1px solid #D3D3D3' }}>{accessIcons(userAccess('contracting'))}</TableRowColumn>
                                      <TableRowColumn style={{ width: '9%', padding: 0, textAlign: 'right' }}>
                                        <IconMenu iconButtonElement={<IconButton iconClassName="tc-icon-more-vert" iconStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}/>}>
                                          <MenuItem primaryText="Edit" onTouchTap={() => {
                                            if (R.contains('write', userAccessInUserManagement)) {
                                              const selectedUser = locationUsers[j];
                                              const locName = R.propOr('', 'locName', selectedUser);
                                              const locs = [{ label: locName, value: locName, locId: selectedUser.locId, locName }];
                                              updateProp({
                                                editUserDialog: true,
                                                editedUser: R.merge(selectedUser, { allLocsSelected: false, locs }),
                                                originalUser: R.merge(selectedUser, { locs }) });
                                              if (sortedUsers) this.setState({ sortedUsers: null, sortBy: '', sortDirection: 'forward' });
                                            } else {
                                              this.props.triggerNoAccessWarning({ noAccessDialog: true, requestingAccessToFeature: 'User Management', requestAccessData: { type: 'locationAccess', loc: R.omit(['users'], loc) } });
                                            }
                                          }}
                                          />
                                        </IconMenu>
                                      </TableRowColumn>
                                    </TableRow>
                                  );
                                })
                              }
                            </TableBody>
                          </Table>
                        </div>
                      </CardText>
                    </Card>
                  );
                })
              }
            </div>
        }
      </div>
    );
  }
}

LocView.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  updateProp: (...args) => dispatch(updateUMProps(...args)),
  triggerNoAccessWarning: payload => dispatch({ type: 'GLOBAL_ERROR_TRIGGERED', payload }),
});

const mapStateToProps = ({ userManagement, user }) => ({
  userId: user.get('id'),
  locAccess: user.get('locAccess'),
  locationSort: userManagement.get('locationSort').toJS(),
  isAccom: user.getIn(['company', 'productType']) === 'Accommodation',
});

export default connect(mapStateToProps, mapDispatchToProps)(LocView);



// WEBPACK FOOTER //
// ./src/app/components/settings/userManagement/views/loc.jsx